import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { isStrictValidEmail } from "@/lib/helpers/email-validation";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const emailSchema = z.object({
  email: z
    .string()
    .min(1, "Email is required")
    .refine((value) => isStrictValidEmail(value), {
      error: "Invalid email",
    }),
  password: z.string().min(6, "Password is too short"),
});

export type EmailLoginFormData = z.input<typeof emailSchema>;

export interface EmailFormReturn extends UseFormReturn<EmailLoginFormData> {
  defaultValues: EmailLoginFormData;
}

const initialFormValues = {
  email: "",
  password: "",
};

export const useEmailLoginForm = (): EmailFormReturn => ({
  defaultValues: initialFormValues,
  ...useForm<EmailLoginFormData>({
    mode: "onChange",
    defaultValues: initialFormValues,
    resolver: zodResolver(emailSchema),
  }),
});
